import { default as BinderClaimsActions } from 'components/features/binder-claims-actions';
import BinderClaimsSummary from 'components/features/binder-claims-summary';
import ClaimContractAllocation from 'components/features/claim-contract-allocation';
import ClaimRegistration from 'components/features/claim-registration';
import ClaimsHistory from 'components/features/claims-history';
import MasterReserves from 'components/features/master-reserves';
import { TFunction } from 'i18next';
import {
  ClaimResponseDto,
  ClaimResponseDtoStatusEnum,
} from 'libs/pinnacle-sdk';

export interface ClaimTabProps {
  claim: ClaimResponseDto;
  includeNext: boolean;
  includeBack: boolean;
  navigateNext: (step?: number) => void;
  navigateBack: (step?: number) => void;
}

export const NUMBER_OF_CLAIM_HEADER_TABS = 5;

export const getClaimConfigTabs = (
  claimStatus: ClaimResponseDtoStatusEnum | undefined,
  t: TFunction
): {
  id: number;
  tab: string;
  component: React.FC<ClaimTabProps>;
  disabled?: boolean;
  hide?: boolean;
}[] => {
  return [
    {
      id: 0,
      tab: t('claim.navigation.claimRegistration'),
      component: ClaimRegistration,
    },
    {
      id: 1,
      tab: t('claim.navigation.masterReserves'),
      component: MasterReserves,
    },
    {
      id: 2,
      tab: t('claim.navigation.contractAllocation'),
      component: ClaimContractAllocation,
    },
    {
      id: 3,
      tab: t('claim.navigation.binderClaimsSummary'),
      component: BinderClaimsSummary,
    },
    {
      id: 4,
      tab: t('claim.navigation.binderClaimsActions'),
      component: BinderClaimsActions,
    },
    {
      id: 5,
      tab: t('claim.navigation.claimsHistory'),
      component: ClaimsHistory,
    },
  ];
};

export const getComponentByTabId = (
  tabId: number | string,
  t: TFunction
): React.FC<ClaimTabProps> => {
  const configTabs = getClaimConfigTabs(undefined, t);
  const tab = configTabs.find((tab) => tab.id === tabId);
  return tab ? tab.component : configTabs[0].component;
};
